const translations = {
  en: {
    title: "Translator",
    uploadButton: "Upload Excel File",
    fileUploaded: "File uploaded:",
    hasTranslations: "This file already has Vietnamese translations.",
    untranslatedRows: "There are {count} untranslated rows.",
    passwordProtected: "This file is password protected. Please enter the password to open it.",
    passwordLabel: "Enter Excel file password",
    openFileButton: "Open File",
    translateButton: "Translate Korean to Vietnamese",
    exportButton: "Export to Excel",
    enterRowNumber: "Enter row number",
    viewRowButton: "View Row",
    contentOfRow: "Content of row {number}:",
    korean: "Korean:",
    vietnamese: "Vietnamese:",
    notTranslated: "(Not translated)",
    language: 'Language',
    model: 'Model',
    resetButton: "Reset",
    problematicRows: "Problematic Rows",
    noProblematicRowsFound: "No problematic rows found.",
    editTitle: "Edit Translations",
    editButton: "Edit Vietnamese Translation",
    editedFileUploaded: "Edited file uploaded:",
    hasEditedTranslations: "This file already has edited Vietnamese translations.",
    uneditedRows: "There are {count} unedited rows.",
    notEdited: "(Not edited)",
    notRefined: "(Not refined)",
    editStatus: "Edit Status:",
    hasEmptyVietnameseTranslations: "This file contains empty Vietnamese translations. Please translate all rows before refining.",
    cannotRefineEmptyTranslations: "Cannot refine translations. Some Vietnamese translations are empty. Please translate all rows before refining.",
    refinedVietnamese: "Refined Vietnamese:",
    translateTab: "Translate",
    editTab: "Edit",
    splitTab: "Split File",
    splitButton: "Split File",
    splitSuccess: "File has been split successfully into {count} files",
    splitProcessing: "Processing file...",
    rowsPerFile: "Rows per file:",
    chooseSaveLocation: "Choose location to save files",
    splitError: "Error splitting file",
    joinTitle: "Join Files",
    joinTab: "Join Files",
    joinButton: "Join Files",
    joinSuccess: "Files have been joined successfully",
    joinError: "Error joining files",
    downloadButton: "Download Joined File",
    selectedFiles: "Selected files:",
    noFilesSelected: "No files selected",
    splitTitle: "Split File",
    statusCompleted: "Completed",
    statusError: "Error",
    statusProcessing: "Processing",
    statusPending: "Pending",
    selectSaveDirectory: "Select Save Directory",
    changeSaveDirectory: "Change Save Directory",
    selectedDirectory: "Selected Directory",
    pleaseSelectSaveDirectory: "Please select a directory to save the edited files",
    errorSavingFile: "Error saving file. Please try again.",
    errorSelectingDirectory: "Error selecting directory. Please try again.",
    apiErrors: "API Errors",
    batchNumber: "Batch",
    errorMessage: "Error Message",
    errorCode: "Error Code",
    errorType: "Type",
    openRouterLimits: {
      rateLimit: "Rate limit per minute",
      tokensRemaining: "Tokens remaining",
      resetDate: "Credit reset date",
      apiError: "API Error",
      noApiKey: "No API key found"
    }
  },
  vi: {
    title: "Trình dịch ngôn ngữ",
    uploadButton: "Tải lên file Excel",
    fileUploaded: "Đã tải lên file:",
    hasTranslations: "File này đã có bản dịch tiếng Việt.",
    untranslatedRows: "Có {count} dòng chưa được dịch.",
    passwordProtected: "File này được bảo vệ bằng mật khẩu. Vui lòng nhập mật khẩu để mở.",
    passwordLabel: "Nhập mật khẩu của file Excel",
    openFileButton: "Mở File",
    translateButton: "Dịch tiếng Hàn sang tiếng Việt",
    exportButton: "Xuất ra Excel",
    enterRowNumber: "Nhập số dòng",
    viewRowButton: "Xem dòng",
    contentOfRow: "Nội dung của dòng {number}:",
    korean: "Tiếng Hàn:",
    vietnamese: "Tiếng Việt:",
    notTranslated: "(Chưa dịch)",
    language: 'Ngôn ngữ',
    model: 'Mô hình',
    resetButton: "Đặt lại",
    problematicRows: "Các dòng có vấn đề",
    noProblematicRowsFound: "Không tìm thấy dòng nào có vấn đề.",
    editTitle: "Hiệu đính bản dịch",
    editButton: "Hiệu đính bản dịch tiếng Việt",
    editedFileUploaded: "Đã tải lên file cần hiệu đính:",
    hasEditedTranslations: "File này đã có bản hiệu đính tiếng Việt.",
    uneditedRows: "Có {count} dòng chưa được hiệu đính.",
    notEdited: "(Chưa hiệu đính)",
    notRefined: "(Chưa được hiệu đính)",
    editStatus: "Trạng thái hiệu đính:",
    hasEmptyVietnameseTranslations: "File này có một số dòng chưa được dịch sang tiếng Việt. Vui lòng dịch tất cả các dòng trước khi hiệu đính.",
    cannotRefineEmptyTranslations: "Không thể hiệu đính. Một số dòng chưa được dịch sang tiếng Việt. Vui lòng dịch tất cả các dòng trước khi hiệu đính.",
    refinedVietnamese: "Tiếng Việt đã hiệu đính:",
    translateTab: "Dịch",
    editTab: "Hiệu Đính",
    splitTab: "Tách File",
    splitButton: "Tách File",
    splitSuccess: "File đã được chia thành {count} files",
    splitProcessing: "Đang xử lý file...",
    rowsPerFile: "Số dòng mỗi file:",
    chooseSaveLocation: "Chọn vị trí lưu files",
    splitError: "Lỗi khi tách file",
    joinTitle: "Gộp files",
    joinTab: "Gộp files",
    joinButton: "Gộp Files",
    joinSuccess: "Các files đã được gộp thành công",
    joinError: "Lỗi khi gộp files",
    downloadButton: "Tải File Đã Gộp",
    selectedFiles: "Các files đã chọn:",
    noFilesSelected: "Chưa chọn files nào",
    splitTitle: "Tách file",
    statusCompleted: "Đã hoàn thành",
    statusError: "Lỗi",
    statusProcessing: "Đang xử lý",
    statusPending: "Đang chờ",
    selectSaveDirectory: "Chọn thư mục lưu",
    changeSaveDirectory: "Đổi thư mục lưu",
    selectedDirectory: "Thư mục đã chọn",
    pleaseSelectSaveDirectory: "Vui lòng chọn thư mục để lưu các file đã hiệu đính",
    errorSavingFile: "Lỗi khi lưu file. Vui lòng thử lại.",
    errorSelectingDirectory: "Lỗi khi chọn thư mục. Vui lòng thử lại.",
    apiErrors: "Lỗi API",
    batchNumber: "Batch",
    errorMessage: "Thông báo lỗi",
    errorCode: "Mã lỗi",
    errorType: "Loại lỗi",
    openRouterLimits: {
      rateLimit: "Giới hạn yêu cầu mỗi phút",
      tokensRemaining: "Số token còn lại",
      resetDate: "Ngày reset credit",
      apiError: "Lỗi API",
      noApiKey: "Không tìm thấy API key"
    }
  }
};

export default translations;
